export default __webpack_public_path__ + "static/media/facebook.564e4e88.svg";